import React from 'react'
import css from '../nav.css'

export default function navbar() {
    return (
        <div id="navbar">
        <a href="#home">Bird Watcher-SQUACK </a>
        <a href="#news">click an image to begin</a>
      </div>
    )
}
